export default __webpack_public_path__ + "ef89544d6899b95617061f92247563ac.svg";